import { FieldType } from "../api.js";
import { BaseModelConvertSpec } from "./base.specs.js";
const BannerConvertSpec = {
  ...BaseModelConvertSpec,
  publishedAt: FieldType.DateTime,
  unpublishedAt: FieldType.DateTime,
  createdAt: FieldType.DateTime,
  updatedAt: FieldType.DateTime
};
export {
  BannerConvertSpec
};
